/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import IconDropdownMenu from './IconDropdownMenu';

export default class PopOver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupVisible: false
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  handleClick = () => {
    if (this.props.toggleParent) {
      this.props.toggleParent();
    }
    this.setState({ popupVisible: !this.state.popupVisible});
  }

  handleOutsideClick = (e) => {
    if (!this.node.contains(e.target)) {
      this.setState({ popupVisible: false });
      if (this.props.hideParent) {
        this.props.hideParent();
      }
    }
  }

  render() {
    const { elem, pills, toggleParent, hideParent, dropdownProps, ...otherProps } = this.props;
    if (dropdownProps.openOnSelect) dropdownProps.openOnSelect = this.handleClick;

    return (
      <div className="popover-container" {...otherProps}>
        <div ref={node => { this.node = node; }}
          onClick={this.handleClick}
        >{ elem }{ pills }
        </div>
        { this.state.popupVisible && <IconDropdownMenu { ... dropdownProps} /> }
      </div>
    );
  }
}

